import { useState, useCallback, useRef } from 'react';

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState({
    isOpen: false,
    position: { x: 0, y: 0 },
    menuType: null, // 'space' | 'file'
    selectedItem: null
  });

  // 메뉴 열림 시간을 추적하여 즉시 닫힘 방지
  const menuOpenTimeRef = useRef(0);

  // 컨텍스트 메뉴 열기
  const openContextMenu = useCallback((event, menuType, selectedItem = null) => {
    event.preventDefault();
    event.stopPropagation();

    // 메뉴 열린 시간 기록
    menuOpenTimeRef.current = Date.now();

    // 새 위치와 데이터로 메뉴 업데이트 (기존 메뉴가 열려있어도 바로 교체)
    setContextMenu({
      isOpen: true,
      position: { x: event.clientX, y: event.clientY },
      menuType,
      selectedItem
    });
  }, []);

  // 컨텍스트 메뉴 닫기
  const closeContextMenu = useCallback((reason = 'unknown') => {
    const timeSinceOpen = Date.now() - menuOpenTimeRef.current;
    console.log(`컨텍스트 메뉴 닫힘 (${reason}):`, Date.now(), '열린지', timeSinceOpen, 'ms 후');
    
    // 100ms 이내에 닫히는 것을 방지 (디버깅용)
    if (timeSinceOpen < 100) {
      console.warn('컨텍스트 메뉴가 너무 빨리 닫혔습니다. 무시합니다.');
      return;
    }

    setContextMenu(prev => ({
      ...prev,
      isOpen: false
    }));
  }, []);

  return {
    contextMenu,
    openContextMenu,
    closeContextMenu
  };
};